import { Content } from '../../types';

export const phnomPenhRoyalPalaceContent: Content = {
  title: 'מתחם הארמון המלכותי בפנום פן',
  imageUrl: 'https://tinyurl.com/phnom-penh-palace-wide',
  introduction: `מתחם הארמון המלכותי בפנום פן הינו אחד האתרים החשובים והמרשימים ביותר בקמבודיה, הן מבחינה היסטורית והן מבחינה ארכיטקטונית. הארמון נבנה בשנת 1866, בתקופתו של המלך נורודום ומשמש מאז כמעונו הרשמי של מלך קמבודיה. במשך השנים עבר המתחם שינויים ושיפוצים, אך הוא ממשיך לשמש סמל השלטון והמסורת הקמבודית.`,
  sections: [
    {
      title: 'היסטוריה ומעמד הארמון',
      content: `למעט תקופת שלטון הקמר רוז', שבה נאלץ המלך נורודום סיהאנוק לגלות לסין, שימש הארמון כבית המלוכה. לאחר תבוסת הקמר רוז' על ידי צבא וייטנאם, חזר המלך לארמון. בשנת 2004 ויתר נורודום סיהאנוק על המלוכה ובנו, נורודום סיהאמוני, ירש את כס המלכות ומתגורר כיום במתחם.`,
      type: 'text',
    },
    {
      title: 'מיקום ותצפית מרחוק',
      content: `חזית הארמון פונה מזרחה, לכיוון נהר המקונג ובשל מיקומו המרכזי ניתן להבחין בו בקלות. מבקרים המגיעים לפנום פן דרך הנהר, במיוחד מכיוון וייטנאם, יכולים לזהות את הארמון המתנשא מעל יתר המבנים לאורך הנהר, בנקודת עיקול יפהפייה של המקונג.`,
      type: 'text',
    },
    {
      title: 'המבנים המרכזיים במתחם',
      content: [
        'המתחם רחב הידיים כולל מגוון מבנים חשובים:',
        'הארמון המלכותי – המבנה המרכזי שבו מתגוררת משפחת המלוכה ומשמש לטקסים רשמיים.',
        'אולם קבלת הפנים (Preah Thineang Chan Chhaya) – מבנה מרשים בעל גג מוזהב, המשמש לטקסים ממלכתיים ולאירוח שגרירים ואורחים רמי דרג.',
        'פגודת הכסף (Wat Preah Keo Morakot) – אחד האתרים הבולטים במתחם והידועה בשל רצפתה המרוצפת ביותר מ-5,000 אריחי כסף טהור. בפנים, מוצגת דמותו של הבודהה הברקת, יחד עם אוצרות נוספים מההיסטוריה הקמבודית.',
        'מבני הקבורה המלכותיים – מבנים בצורת פגודות המשמשים כמקומות מנוחה אחרונה לבני משפחת המלוכה לדורותיהם.',
        'הספרייה המלכותית – מבנה שבו נשמרים כתבי קודש וחומרים היסטוריים יקרי ערך.',
        'הגנים המלכותיים – שטחים מטופחים המשלבים צמחייה טרופית, עצים עתיקים ובריכות נוי, המעניקים למתחם אווירה פסטורלית.',
      ],
      type: 'list',
    },
    {
      title: 'חוויית הביקור וחשיבות המתחם',
      content: `המתחם משמש לא רק כמרכז שלטוני אלא גם כעדות חיה להיסטוריה ולמסורת של קמבודיה. הארכיטקטורה המרשימה, הפרטים העיצוביים המורכבים והאווירה הייחודית הופכים אותו לאתר חובה לכל מבקר בפנום פן. ניתן ללמוד מהביקור על התפתחות הממלכה, התרבות והאמנות הקמבודית, תוך שיטוט בין המבנים ההיסטוריים והגנים המטופחים.`,
      type: 'text',
    },
    {
      title: 'מידע שימושי למבקרים',
      content: [
        'שעות פתיחה: 08:00-17:00 מדי יום (למעט אירועים רשמיים ולפיכך, יש לבדוק מראש)',
        'עלות כניסה: 10 דולר לאדם (מגיל 6 ומעלה)',
        'קוד לבוש: יש להקפיד על לבוש צנוע – אין להיכנס עם בגדים קצרים או חולצות ללא שרוולים',
        'צילום: אסור לצלם בתוך הארמון עצמו, אך ניתן לצלם ברחבי המתחם',
        'תחבורה: המתחם נמצא במרכז העיר ונגיש בקלות, ברגל, בטוק-טוק או במונית',
        'טיפ למבקרים: יש להתעלם מנהגי טוק-טוק הטוענים שהמתחם סגור – מדובר בתרגיל נפוץ כדי להפנות תיירים לאתרים אחרים.',
      ],
      type: 'list',
    },
    {
      title: 'בשורה התחתונה',
      content: `בשורה התחתונה, מתחם הארמון המלכותי בפנום פן הינו עדות חיה להיסטוריה הקמבודית ולמורשת המלכותית של המדינה. המבנים המפוארים, פגודת הכסף והגנים המטופחים יוצרים חוויה בלתי נשכחת לכל מי שמבקר במקום. אם הינכם שוהים בפנום פן, אל תחמיצו את ההזדמנות לגלות את אחד האתרים המרשימים ביותר בעיר.`,
      type: 'text',
    },
  ],
};
